// Arabic platform-operations strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enOps } from './en-ops.ts';
import type { Message } from './types.ts';

export const arOps: { readonly [K in keyof typeof enOps]: Message } = {
  'api.opsJobStale': 'تغيّرت هذه المهمة منذ أن اطّلعت عليها. أعِد تحميلها ثم قرّر من جديد.',
  'api.opsJobState': 'هذا الإجراء غير متاح أثناء حالة المهمة: {state}.',
  'v.opsReconcile': 'أكِّد أنك تحققت من النتيجة الخارجية قبل إعادة تشغيل هذه المهمة.',
  'v.opsReasonShort': 'اكتب سببًا من 3 أحرف على الأقل.',

  'ops.state.queued': 'في قائمة الانتظار',
  'ops.state.scheduled': 'مجدولة',
  'ops.state.retrying': 'قيد إعادة المحاولة',
  'ops.state.in_flight': 'قيد التنفيذ',
  'ops.state.dead_letter': 'متوقفة (رسالة ميتة)',
  'ops.state.resolved': 'سُوّيت يدويًا',
  'ops.state.dispatched': 'سُلّمت',
  'ops.effect.external': 'أثر خارجي',
  'ops.effect.internal': 'داخلي',
  'ops.effect.none': 'لا مشترك',

  'ops.title': 'عمليات المنصة',
  'ops.intro': 'راقب الأعمال الخلفية وأدلة الاستعادة وقرارات النشر. سلامة الاتصال لا تعني نجاح العملية.',
  'ops.tabsLabel': 'أقسام عمليات المنصة',
  'ops.tab.jobs': 'المهام الخلفية',
  'ops.tab.profile': 'ملف النشر',
  'ops.tab.recovery': 'الاستعادة والضوابط',
  'ops.m.dead': 'الرسائل الميتة',
  'ops.m.deadSub': 'تحتاج إلى قرار من المشغّل',
  'ops.m.retrying': 'قيد إعادة المحاولة',
  'ops.m.retryingSub': 'فشلت مرة على الأقل؛ تُعاد تلقائيًا',
  'ops.m.waiting': 'بانتظار التنفيذ',
  'ops.m.waitingSub': 'في الانتظار أو مجدولة أو قيد التنفيذ',
  'ops.m.oldest': 'الأقدم استحقاقًا',
  'ops.m.oldestSub': 'عمر أقدم مهمة تنتظر التنفيذ',
  'ops.seconds': '{count} ث',
  'ops.minutes': '{count} د',
  'ops.hours': '{count} س',

  'ops.health.title': 'سلامة الخدمة',
  'ops.health.sub': 'الحالات فقط؛ التفاصيل التقنية تبقى في سجلات المشغّل.',
  'ops.health.database': 'قاعدة البيانات',
  'ops.health.schema': 'المخطط',
  'ops.health.objects': 'تخزين الملفات',
  'ops.health.workers': 'العمّال الخلفيون',
  'ops.health.ok': 'متاح',
  'ops.health.unavailable': 'غير متاح',
  'ops.schema.current': 'محدَّث',
  'ops.schema.pending': 'توجد ترحيلات معلّقة',
  'ops.schema.ahead': 'أحدث من هذا الإصدار (متوافق مع التراجع)',
  'ops.schema.drift': 'تغيّر بعد الإصدار',
  'ops.schema.unknown': 'غير معروف',
  'ops.workers.active': { zero: 'لا يوجد عامل نشط', one: 'عامل نشط واحد', two: 'عاملان نشطان', few: '{count} عمّال نشطون', many: '{count} عاملًا نشطًا', other: '{count} عامل نشط' },
  'ops.workers.lastSeen': 'آخر نبضة {time}',
  'ops.workers.never': 'لم تُسجَّل أي نبضة لعامل',

  'ops.jobs.title': 'طابور العامل',
  'ops.jobs.sub': 'المهام في مواقعك. لا تُعرض قيم الحمولة أبدًا.',
  'ops.filter.state': 'الحالة',
  'ops.filter.allStates': 'كل الحالات',
  'ops.filter.site': 'الموقع',
  'ops.filter.allSites': 'كل مواقعي',
  'ops.col.job': 'المهمة',
  'ops.col.site': 'الموقع',
  'ops.col.state': 'الحالة',
  'ops.col.attempts': 'المحاولات',
  'ops.col.when': 'المحاولة التالية',
  'ops.col.action': 'الإجراء',
  'ops.inspect': 'فحص',
  'ops.empty': 'لا توجد مهام مطابقة لهذه المرشحات.',
  'ops.orgLevel': 'المؤسسة',
  'ops.loaded': { zero: 'لم تُحمَّل أي مهمة', one: 'حُمّلت مهمة واحدة', two: 'حُمّلت مهمتان', few: 'حُمّلت {count} مهام', many: 'حُمّلت {count} مهمة', other: 'حُمّلت {count} مهمة' },
  'ops.tableLabel': 'المهام الخلفية',

  'ops.job.title': 'تفاصيل المهمة',
  'ops.job.sub': 'الحقائق للقراءة أولًا؛ تُسجَّل الإجراءات مع السبب الذي تذكره.',
  'ops.f.topic': 'الموضوع',
  'ops.f.effect': 'الأثر الجانبي',
  'ops.f.state': 'الحالة',
  'ops.f.attempts': 'المحاولات',
  'ops.f.operatorRetries': 'إعادات المشغّل',
  'ops.f.created': 'أُنشئت',
  'ops.f.available': 'المحاولة التالية',
  'ops.f.lease': 'الحجز حتى',
  'ops.f.deadLettered': 'أُوقفت',
  'ops.f.resolved': 'سُوّيت',
  'ops.f.lastError': 'آخر خطأ (منقّح)',
  'ops.f.payloadKeys': 'حقول الحمولة',
  'ops.f.correlation': 'مرجع التتبّع',
  'ops.f.resolution': 'التسوية',
  'ops.history': 'سجل المشغّل',
  'ops.history.none': 'لا توجد إجراءات من المشغّل بعد.',
  'ops.act.retry': 'إعادة المحاولة',
  'ops.act.dead_letter': 'نقل إلى الرسائل الميتة',
  'ops.act.resolve': 'تعليم كمسوّاة',
  'ops.reason': 'السبب',
  'ops.reasonHint': 'يُسجَّل في سجل التدقيق.',
  'ops.external.note': 'ترسل هذه المهمة شيئًا خارج Passage. ربما توقف العامل بعد حدوث الأثر؛ تحقّق من النتيجة الخارجية قبل إعادة التشغيل.',
  'ops.external.check': 'تحققت من النتيجة الخارجية: لم تحدث، أو أن تكرارها مقبول.',
  'ops.done.retry': 'أُعيدت المهمة إلى الطابور لمحاولة أخرى.',
  'ops.done.dead_letter': 'نُقلت المهمة إلى الرسائل الميتة.',
  'ops.done.resolve': 'عُلّمت المهمة كمسوّاة.',
  'ops.noOperate': 'يمكنك عرض هذه المهمة لكن لا يمكنك اتخاذ إجراء عليها.',
  'ops.noActions': 'لا يوجد إجراء متاح في هذه الحالة.',

  'ops.profile.title': 'تخطيط النشر',
  'ops.profile.sub': 'حقائق للقراءة فقط. الاستضافة والإقامة وأهداف الاستعادة قرارات يتخذها المالك.',
  'ops.profile.active': 'الملف النشط',
  'ops.profile.build': 'الإصدار',
  'ops.profile.unversioned': 'إصدار محلي بلا رقم',
  'ops.profile.schema': 'إصدار المخطط',
  'ops.profile.region': 'منطقة الاستضافة',
  'ops.profile.availability': 'التوافر',
  'ops.profile.residency': 'ادعاء إقامة البيانات',
  'ops.profile.residencyNo': 'لا يمكن ادعاؤه: يجب إثبات كل تدفق للبيانات، بما فيه السجلات والنسخ الاحتياطية، داخل المنطقة المعتمدة.',
  'ops.profile.residencyYes': 'مُثبت لكل تدفقات البيانات',
  'ops.profile.flows': 'تدفقات البيانات في الملف النشط',
  'ops.profile.options': 'خيارات النشر',
  'ops.decisionRequired': 'يتطلب قرارًا',
  'ops.col.profile': 'الخيار',
  'ops.col.status': 'الحالة',
  'ops.col.decisions': 'القرارات المفتوحة',
  'ops.col.flow': 'تدفق البيانات',
  'ops.col.location': 'الموقع',
  'ops.none': 'لا يوجد',
  'ops.pid.local-production-like': 'محلي مماثل للإنتاج (بيانات اصطناعية)',
  'ops.pid.managed-cloud': 'سحابة تديرها Scinops',
  'ops.pid.uae-cloud': 'سحابة مستضافة في الإمارات',
  'ops.pid.private-cloud': 'سحابة خاصة لدى العميل',
  'ops.pid.on-premises': 'داخل مقر العميل',
  'ops.pstatus.rehearsed-locally': 'جُرّب محليًا',
  'ops.pstatus.documented': 'موثّق، غير منشور',
  'ops.pstatus.not-started': 'لم يبدأ',
  'ops.flow.database': 'قاعدة البيانات',
  'ops.flow.objects': 'الملفات المرفوعة',
  'ops.flow.backups': 'النسخ الاحتياطية',
  'ops.flow.logs': 'السجلات',
  'ops.flow.email': 'تسليم البريد الإلكتروني',
  'ops.flow.ai': 'مساعدة الذكاء الاصطناعي',
  'ops.fstatus.verified-locally': 'تُحقّق منه محليًا',
  'ops.fstatus.undecided': 'لم يُحسم',
  'ops.fstatus.unverified': 'غير مُتحقَّق منه',
  'ops.fstatus.disabled': 'معطّل',
  'ops.avail.single-instance': 'نسخة واحدة (بلا تحويل عند الفشل)',
  'ops.avail.undecided': 'لم يُحسم',
  'ops.avail.not-designed': 'غير مصمَّم',
  'ops.service.title': 'ملف الدعم والخدمة',
  'ops.service.sub': 'لا تُفترض أي شروط دعم قبل وجود اتفاقية.',
  'ops.service.edition': 'الإصدار التجاري',
  'ops.service.agreement': 'الاتفاقية',
  'ops.service.contacts': 'جهات الاتصال',
  'ops.service.escalation': 'التصعيد',
  'ops.service.responseTerms': 'شروط الاستجابة',
  'ops.service.undecided': 'لم يُحسم — لا يُفترض أي زمن استجابة أو تغطية على مدار الساعة',

  'ops.recovery.title': 'القبول التشغيلي',
  'ops.recovery.sub': 'لا تُقدَّم أي ضمانات للاستعادة.',
  'ops.recovery.rpo': 'هدف نقطة الاستعادة (RPO)',
  'ops.recovery.rto': 'هدف زمن الاستعادة (RTO)',
  'ops.recovery.retention': 'مدة الاحتفاظ بالنسخ الاحتياطية',
  'ops.recovery.failover': 'التحويل عند الفشل',
  'ops.failover.not-designed': 'غير مصمَّم',
  'ops.failover.designed': 'مصمَّم، لم يُجرَّب',
  'ops.failover.rehearsed': 'جُرّب',
  'ops.runs.title': 'النسخ الاحتياطية والتجارب',
  'ops.runs.sub': 'تشغيلات مقيسة. النسخة الاحتياطية دون استعادة مُتحقَّق منها ليست دليلًا على إمكانية الاستعادة.',
  'ops.runs.none': 'لم تُسجَّل أي تشغيلات بعد.',
  'ops.col.run': 'التشغيل',
  'ops.col.finished': 'انتهى',
  'ops.col.duration': 'المدة',
  'ops.col.outcome': 'النتيجة',
  'ops.run.backup': 'نسخة احتياطية',
  'ops.run.restore_rehearsal': 'تجربة استعادة (مُتحقَّق منها)',
  'ops.run.upgrade_rehearsal': 'تجربة ترقية وتراجع',
  'ops.run.predeploy_check': 'فحص ما قبل النشر',
  'ops.outcome.succeeded': 'نجح',
  'ops.outcome.failed': 'فشل',
  'ops.durationMs': '{seconds} ث',
  'ops.controls.title': 'مطابقة الضوابط',
  'ops.controls.sub': 'مبنية على الأدلة وليست شهادة. الضابط بلا مرجع متطلب مُقدَّم أو بلا دليل يُعدّ فجوة.',
  'ops.col.control': 'الضابط',
  'ops.col.requirement': 'المتطلب',
  'ops.col.evidence': 'الدليل',
  'ops.col.owner': 'المسؤول',
  'ops.requirementMissing': 'المرجع بانتظار التزويد',
  'ops.ownerMissing': 'غير مُسند',
  'ops.col.review': 'المراجعة',
  'ops.reviewMissing': 'لم تتم مراجعته',
  'ops.reviewedBy': '{date} · {reviewer}',
  'ops.cstatus.evidenced-locally': 'مُثبت محليًا',
  'ops.cstatus.gap': 'فجوة',
  'ops.control.tenant-isolation': 'عزل بيانات المؤسسات',
  'ops.control.least-privilege-db-roles': 'أدوار قاعدة بيانات بأقل صلاحيات',
  'ops.control.authorization-default-deny': 'تفويض بالرفض افتراضيًا',
  'ops.control.append-only-audit': 'سجل تدقيق للإضافة فقط',
  'ops.control.secrets-outside-images': 'إبقاء الأسرار خارج الصور والشيفرة',
  'ops.control.log-redaction': 'تشخيص بلا بيانات شخصية أو أسرار',
  'ops.control.backup-restore-verified': 'نسخ احتياطي واستعادة مُتحقَّق منهما',
  'ops.control.encryption-in-transit': 'التشفير أثناء النقل',
  'ops.control.encryption-at-rest-database': 'تشفير قاعدة البيانات أثناء التخزين',
  'ops.control.malware-scanning': 'فحص الملفات المرفوعة من البرمجيات الخبيثة',
  'ops.control.data-residency': 'إقامة البيانات',
  'ops.control.incident-response': 'مسؤولية الاستجابة للحوادث',
  'ops.control.high-availability': 'التوافر العالي',
};
